<template>
  <div class="d-flex flex-column">
    <template v-if="answers.length">
      <!-- ONE CORRECT -->
      <template v-if="question.type_id === 1">
        <div v-for="answer in answers" :key="answer.id" class="d-flex align-items-center mb-1">
          <b-form-checkbox v-model="answer.is_correct" @change="setRadioFlags(answer)" />

          <b-form-input
            v-model.trim="answer.value"
            class="ml-1"
            size="sm"
            placeholder="Введите текст ответа"
            @change="onAnswerEdit(answer, 'value')"
          />
          <b-icon-x @click="deleteAnswer(answer.id)" class="remove-answer ml-1" />
        </div>
      </template>
      <!-- MULTIPLE CORRECT -->
      <template v-else-if="question.type_id === 2">
        <div v-for="answer in answers" :key="answer.id" class="d-flex align-items-center mb-1">
          <b-form-checkbox v-model="answer.is_correct" @change="onAnswerEdit(answer, 'is_correct')" />

          <b-form-input
            v-model.trim="answer.value"
            class="ml-1"
            size="sm"
            placeholder="Введите текст ответа"
            @change="onAnswerEdit(answer, 'value')"
          />
          <b-icon-x @click="deleteAnswer(answer.id)" class="remove-answer ml-1" />
        </div>
      </template>
      <!-- OPEN -->
      <template v-else-if="question.type_id === 3">
        <b-form-input
          v-model="answers[0].value"
          @change="onAnswerEdit(answers[0], 'value')"
          placeholder="Введите текст ответа"
        />
      </template>
      <!-- OPEN + MODERATION -->
      <template v-else-if="question.type_id === 4">
        <span class="text-muted" style="font-size: 12px">
          Ученику будет предложено ввести развёрнутый ответ на странице выполнения теста.
          <br />
          Вы сможете видеть эти ответы в профиле ученика
        </span>
      </template>
    </template>

    <div v-if="[1, 2].includes(question.type_id)" class="add-answer mt-3" @click="addAnswer">Добавить ответ</div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/sass/custom/colors.scss";
.add-answer {
  font-size: 12px;
  width: fit-content;
  cursor: pointer;
  color: $primary;
  &:hover {
    color: $primary-700;
  }
}
.remove-answer {
  cursor: pointer;
  &:hover {
    background: #eee;
    border-radius: 0.25rem;
  }
}
</style>

<script>
import { BIconX } from "bootstrap-vue";
import Api from "shared/service/api/api";

export default {
  name: "LessonTestQuestionAnswers",
  components: { BIconX },
  props: {
    question: {
      type: Object,
      required: true,
    },
    reloadAnswers: {
      type: Number,
      required: false,
    },
    isManage: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    ["question.type_id"]() {
      // при смене типа вопроса необходимо очистить текущие ответы перед их перезагрузкой
      this.answers = [];
    },
    reloadAnswers() {
      // при смене типа вопроса необходимо перезагрузить ответов на него
      this.load();
    },
  },
  computed: {
    lessonId() {
      return Number(this.$route.params.lessonId);
    },
    apiNamespace() {
      return this.isManage ? Api.admin.course.lesson.test.question.answer : Api.course.lesson.test.question.answer;
    },
  },
  data() {
    return {
      answers: [],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.apiNamespace.all(this.lessonId, this.question.id).then((response) => {
        this.answers = response.data;
      });
    },
    addAnswer() {
      this.apiNamespace
        .create(this.lessonId, this.question.id)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          this.load();
        })
        .catch(() => this.$alert.error("Ошибка сохранения ответа"));
    },
    saveAnswer(answer, reload = true) {
      this.apiNamespace
        .save(this.lessonId, answer)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          !answer.id && this.answers.push({ ...response.data, ...answer });
        })
        .catch(() => this.$alert.error("Ошибка сохранения ответа"))
        .finally(() => {
          reload && this.load();
        });
    },
    deleteAnswer(answerId) {
      if (this.answers.length === 1) {
        this.$alert.error("На вопрос должен быть хотя бы один ответ");
        return;
      }
      if (
        this.answers.filter((answer) => answer.is_correct).length === 1 &&
        this.answers.find((answer) => answer.id === answerId).is_correct
      ) {
        this.$alert.error("Нельзя удалить единственный правильный ответ");
        return;
      }

      this.apiNamespace
        .delete(this.lessonId, answerId)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }

          this.answers = this.answers.filter((a) => a.id !== answerId);
        })
        .catch(() => this.$alert.error("Ошибка удаления ответа"));
    },
    onAnswerEdit(answer, fieldName) {
      if (
        fieldName === "is_correct" &&
        !answer.is_correct &&
        !this.answers.filter((answer) => answer.is_correct).length
      ) {
        answer.is_correct = true;
        this.$alert.error("Должен быть хотя бы один правильный ответ");
      }

      if (fieldName === "value" && !answer[fieldName]) {
        return;
      }

      this.saveAnswer(
        {
          id: answer.id,
          [fieldName]: answer[fieldName],
        },
        false
      );
    },
    setRadioFlags(answer) {
      // обновляем флаг is_correct у всех остальных ответов
      this.answers = this.answers.map((a) => {
        a.is_correct = a.id === answer.id;
        return a;
      });
      this.onAnswerEdit(answer, "is_correct");
    },
  },
};
</script>
